(() => {
 if(window.akumaEditorialProductLoaded)return;
 window.akumaEditorialProductLoaded=true;
 let frame;
 const update=()=>{
  frame=null;
  let headerBottom=0;
  document.querySelectorAll('.shopify-section-group-header-group').forEach(el=>{const r=el.getBoundingClientRect();if(r.top<innerHeight&&r.bottom>0)headerBottom=Math.max(headerBottom,r.bottom);});
  document.querySelectorAll('.akuma-editorial-product .product__info-container').forEach(info=>{
   // Tall panels scroll until their bottom is visible, then stick inside the gallery row.
   const top=Math.min(headerBottom+16,innerHeight-info.offsetHeight-20);
   info.style.setProperty('--akuma-product-sticky-top',`${Math.round(top)}px`);
  });
 };
 const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
 const observer=new ResizeObserver(schedule);
 const refresh=()=>{observer.disconnect();document.querySelectorAll('.akuma-editorial-product .product__info-container,.shopify-section-group-header-group').forEach(el=>observer.observe(el));schedule();};
 addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});
 document.addEventListener('shopify:section:load',refresh);document.addEventListener('shopify:section:unload',refresh);
 refresh();
})();
